import { Component, State, Prop, h, Element, Host } from '@stencil/core';
import { Comment } from './interfaces';
import CheckIcon from "../../assets/svg/check.svg"
import Reply from "../../assets/svg/reply.svg"
import ThumbsUp from "../../assets/svg/thumbs-up.svg"

@Component({
  tag: 'salla-comment-item',
  styleUrl: 'salla-comments.scss',
})
export class SallaCommentItem {

  constructor() {
    salla.lang.onLoaded(() => {
      const setNestedAsync = (lang, key, value) => {
        return new Promise((resolve) => {
          salla.helpers.setNested(salla.lang.messages[lang], key, value);
          resolve(true);
        });
      };

      const setTranslations = async () => {
        await setNestedAsync('ar.trans', 'blocks.comments.helpful', 'مفيد');
        await setNestedAsync('en.trans', 'blocks.comments.helpful', 'Helpful');

        this.helpfulLabel = salla.lang.getWithDefault('blocks.comments.helpful', 'مفيد');
      }



      this.has_bought_trans = salla.lang.get('blocks.comments.has_bought')
      this.rated_trans = salla.lang.get('pages.rating.rated')
      this.waiting_approval_trans = salla.lang.get('blocks.comments.waiting_approval')
      this.has_order_trans = salla.lang.get('blocks.comments.has_order')

      setTranslations()
    })
  }
  componentDidLoad() {
    this.likesCount = this.comment.likes_count;

    try {
      this.likedComments = JSON.parse(localStorage.getItem('liked_comments') || '[]');
      if (this.likedComments.includes(this.comment.id)) {
        this.likeBtn.classList.add('liked');
        this.likeBtn.fill = "solid"
      }
    } catch {
      salla.log('Bad json for liked_comments');
    }
  }
  @Element() host: HTMLElement;
  private likeBtn: HTMLSallaButtonElement;
  private modal: HTMLSallaModalElement;
  /**
   * Single Comment Instance
  */
  @Prop() comment: Comment;

  /**
   * Hide Bought
  */
  @Prop() hideBought: Boolean;

  // Translations
  @State() has_bought_trans = salla.lang.get('blocks.comments.has_bought');
  @State() rated_trans = salla.lang.get('pages.rating.rated');
  @State() waiting_approval_trans = salla.lang.get('blocks.comments.waiting_approval');
  @State() has_order_trans = salla.lang.get('blocks.comments.has_order');
  @State() allowLikes = salla.config.get('store.settings.rating.allow_likes');
  @State() allowAttachImages = salla.config.get('store.settings.rating.allow_attach_images');
  @State() helpfulLabel = salla.lang.getWithDefault('blocks.comments.helpful', 'مفيد');
  @State() likesCount = 0;
  @State() likedComments = [];

  private getReplies() {
    return Array.isArray(this.comment.replies) ? this.comment.replies : [this.comment.replies]
  }

  private getDate(dateString) {
    const [datePart] = dateString.split(' ');
    const [year, month, day] = datePart.split('-');
    const formattedDate = `${parseInt(day, 10)}/${parseInt(month, 10)}/${parseInt(year, 10)}`;
    return formattedDate;
  }

  private getTime(dateString) {
    const [, timePart] = dateString.split(' ');
    const [hours, minutes] = timePart.split(':');
    const formattedTime = `${parseInt(hours, 10)}:${parseInt(minutes, 10)}`;
    return formattedTime;
  }

  private async toggleLike() {
    if (salla.config.isGuest()) {
      return salla.notify.error(salla.lang.get('common.messages.must_login'));
    }
    this.likedComments = JSON.parse(localStorage.getItem('liked_comments') || '[]')
    const isLiked = this.likedComments.includes(this.comment.id);

    try {
      const endpoint = isLiked ? `rating/${this.comment.id}/unlike` : `rating/${this.comment.id}/like`;
      const res = await salla.api.request(endpoint, '', 'put');
      salla.log(res.message);

      if (isLiked) {
        this.likeBtn.classList.remove('liked');
        this.likeBtn.fill = 'outline';
        this.updateLikedComments(this.comment.id, false);
        this.likesCount--;
      } else {
        this.likeBtn.classList.add('liked');
        this.likeBtn.fill = 'solid';
        this.updateLikedComments(this.comment.id, true);
        this.likesCount++;
      }
    } catch (e) {
      if (e.response.status == 409) {
        if (this.likeBtn.classList.contains('liked')) {
          this.likeBtn.fill = 'outline';
          this.likeBtn.classList.remove('liked');
          this.updateLikedComments(this.comment.id, false);
          this.likesCount--;
        } else {
          this.likeBtn.fill = 'solid';
          this.likeBtn.classList.add('liked');
          salla.logger.warn('Like already exists');
          this.updateLikedComments(this.comment.id, true);
        }
      }
    }
  }

  private updateLikedComments(commentId: number, add: boolean) {
    this.likedComments = JSON.parse(localStorage.getItem('liked_comments') || '[]')
    if (add) {
      if (!this.likedComments.includes(commentId)) {
        this.likedComments.push(commentId);
      }
    } else {
      this.likedComments = this.likedComments.filter(id => id !== commentId);
    }

    localStorage.setItem('liked_comments', JSON.stringify(this.likedComments));
  }




  render() {
    let isAdmin = this.comment.type == 'admin';
    return (
      <Host class={isAdmin ? 's-comments-item-admin' : 's-comments-item'}>
        <div class={{ "s-comments-item-wrapper": !isAdmin, "s-comments-item-admin-wrapper": isAdmin }} id={`s-comments-item-${this.comment.id}`}>
          <div class="s-comments-item-inner s-comments-flex-1">
            {isAdmin && <span class="s-comments-item-reply-icon" innerHTML={Reply}></span>}
            <div class="s-comments-item-avatar">
              <img data-src={this.comment?.avatar}
                alt={this.comment?.name} src={this.comment?.avatar}
                class="s-comments-item-avatar-img lazy" />
            </div>
            <div class="s-comments-flex-1">
              <div class="s-comments-item-user-wrapper">
                <div class="s-comments-item-user-info">
                  <h3 class="s-comments-item-user-info-name">{this.comment?.name}</h3>

                  {(this.comment.has_order || !!this.comment.rating) && !this.comment.is_pending && !this.hideBought ?
                    <div class="s-comments-flex">
                      {this.comment.has_order ?
                        [<span class="s-comments-item-has-order-check-icon" innerHTML={CheckIcon}></span>,
                        <span class="s-comments-item-has-order-check-text">
                          {this.has_bought_trans} {this.comment.rating ? ', ' : ''}
                        </span>] : null
                      }
                      {!!this.comment.rating ?
                        <span class="s-comments-item-rated-widget">{
                          this.rated_trans}</span> : null}
                    </div>
                    : null}
                </div>

                <p class="s-comments-item-timestamp s-ltr"> {this.getDate(this.comment.created_at?.date)} <span class="s-comments-item-time"> - {this.getTime(this.comment.created_at?.date)} </span></p>

                {!!this.comment.rating || !!this.comment.stars ?
                  <salla-rating-stars size="mini" class="s-comments-item-stars" value={this.comment.rating || this.comment.stars}></salla-rating-stars>
                  : null}
              </div>

              <div class="s-comments-item-content">
                <p innerHTML={this.comment.content}></p>

                {this.allowAttachImages && <div class="s-comments-item-images">
                  {this.comment.images.map((image: string, index) => (
                    <img key={index} src={image} alt="" onClick={() => this.modal.open()} />
                  ))}
                  <salla-modal ref={modal => this.modal = modal} width="sm">
                    <salla-slider
                      id={`s-comments-item-${this.comment.id}-images`}
                      class="s-comments-item-images-slider"
                      type="thumbs"
                      auto-height
                      showControls={this.comment.images.length > 1 ? true : false}
                      show-thumbs-controls="false">
                      <div slot='items'>
                        {this.comment.images.map((image: string, index) => (
                          <img key={index} src={image} alt="" />
                        ))}
                      </div>

                      <div slot="thumbs">
                        {this.comment.images.map((image: string, index) => (
                          <div class="s-comments-item-images-slider-thumb">
                            <img key={index} src={image} alt="" />
                          </div>
                        ))}
                      </div>
                    </salla-slider>
                  </salla-modal>
                </div>}

                {this.allowLikes && !isAdmin && salla.url.is_page('product.single') ? <salla-button ref={el => this.likeBtn = el} class={`s-comments-item-like-btn ${this.likedComments.includes(this.comment.id) ? 'liked' : ''}`} loaderPosition='center' fill='outline' size='small' onClick={() => this.toggleLike()}>
                  <span>{this.helpfulLabel} {this.likesCount > 0 ? `(${this.likesCount})` : ''}</span>
                  <span innerHTML={ThumbsUp}></span>
                </salla-button> : ''}
                {this.comment.is_pending ?
                  <span
                    class="s-comments-item-pending-text">{this.waiting_approval_trans}</span> : null}
                {/* {this.comment.has_order ?
                  <span data-toggle="tooltip" data-placement="right">{this.has_order_trans}</span>
                  : null} */}
              </div>
            </div>
          </div>
          {!!this.getReplies().length && !isAdmin ?
            this.getReplies().map((reply: Comment) => {
              return <div><salla-comment-item comment={reply}></salla-comment-item></div>
            }) : null}
        </div>
      </Host>
    );
  }

}
